<template>
  <app-chip
    class="border bg-white text-black"
    icon="ph:lightning-fill"
    :size="size"
  >
    {{ $t("teacher.pinned_label") }}
  </app-chip>
</template>

<script lang="ts" setup>
defineProps<{
  size?: "small";
}>();
</script>
